import { useNavigate } from "react-router-dom";

export function ErrorFallback({ error, resetErrorBoundary }) {
    const navigate = useNavigate();

    const handleReset = () => {
        resetErrorBoundary();
        navigate('/');
    };

    return (
        <div className="container d-flex justify-content-center align-items-center min-vh-100 ">
            <div className="text-center p-5 rounded-4 shadow-lg" style={{
                background: '',
                maxWidth: '500px',
                width: '100%',
            }}>
                <div className="mb-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="#dc3545" viewBox="0 0 16 16" className="bi bi-exclamation-triangle-fill">
                        <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
                    </svg>
                </div>
                <h3 className="mb-3 fw-bold text-danger">Oops! Something went wrong</h3>

                <div className="alert alert-danger bg-danger bg-opacity-10 border-danger mb-2 text-start">
                    <div className="d-flex">
                        <div className="flex-shrink-0 me-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" fill="#dc3545" viewBox="0 0 16 16" className="bi bi-bug-fill mt-1">
                                <path d="M4.978.855a.5.5 0 1 0-.956.29l.41 1.352A4.985 4.985 0 0 0 3 6h10a4.985 4.985 0 0 0-1.432-3.503l.41-1.352a.5.5 0 1 0-.956-.29l-.291.956A4.978 4.978 0 0 0 8 1a4.979 4.979 0 0 0-2.731.811l-.29-.956z" />
                                <path d="M13 6v1H8.5v8.975A5 5 0 0 0 13 11h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 1 0 1 0v-.5a1.5 1.5 0 0 0-1.5-1.5H13V9h1.5a.5.5 0 0 0 0-1H13V7h.5A1.5 1.5 0 0 0 15 5.5V5a.5.5 0 0 0-1 0v.5a.5.5 0 0 1-.5.5H13zm-5.5 9.975V7H3V6h-.5a.5.5 0 0 1-.5-.5V5a.5.5 0 0 0-1 0v.5A1.5 1.5 0 0 0 2.5 7H3v1H1.5a.5.5 0 0 0 0 1H3v1h-.5A1.5 1.5 0 0 0 1 11.5v.5a.5.5 0 1 0 1 0v-.5a.5.5 0 0 1 .5-.5H3a5 5 0 0 0 4.5 4.975z" />
                            </svg>
                        </div>
                        <div>
                            <p className="mb-2">Our team has been notified and we're working to fix this issue.</p>
                        </div>
                    </div>
                </div>
                <button
                    className="w-100 btn btn-primary mt-1 rounded-3"
                    onClick={handleReset}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" fill="currentColor" viewBox="0 0 16 16" className="bi bi-house-door me-2">
                        <path d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                    </svg>
                    Back to Home
                </button>
            </div>
        </div>
    );
}